<template>
  <div>
    <BaseList
      :columns="columns"
      :data="TotalInfo && TotalInfo.rows ? TotalInfo.rows : []"
      :pagination="
        TotalInfo
          ? {
              total: TotalInfo.count,
              current: TotalInfo.page,
              pageSize: TotalInfo.limit,
            }
          : {}
      "
      :titleAdd="$t('i18nCommon.AddCategory')"
      :isShowCategory="true"
      @change="handleTableChange"
      @addData="addData"
      @editRow="editRow"
      @deleteRow="deleteRow"
      @onDblclick="onDblclick"
      @loadDataFilter="loadDataFilter"
    >
    </BaseList>
    <div v-if="isShow && category && Object.keys(category).length > 0">
      <a-modal v-model:open="isShow" :closable="false" centered :width="800">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Category") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              label-position="left"
              :size="formSize"
              status-icon
            >
              <div class="flex columns-2">
                <a-form-item prop="name" testek="name" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                    </div>
                    <a-input v-model:value="category.categoryName" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item class="w-full" prop="status" testek="status">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Status") }}
                    </div>
                    <a-input v-model:value="category.status" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="description" testek="description" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Description") }}
                    </div>
                    <a-input
                      v-model:value="category.cateDesc"
                      class="w-full"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>
<script>
import BaseList from "@/views/base/BaseList.vue";
import dataFake from "@/data/dataFake";
import { mapActions, mapGetters } from "vuex";
import { ModuleCategory } from "@/store/module-const";
import { Modal } from "ant-design-vue";
export default {
  name: "CategoryList",
  components: {
    BaseList,
  },
  data() {
    return {
      dataSource: dataFake.Products,
      columns: [],
      pagination: {
        total: 200,
        current: 1,
        pageSize: 20,
      },
      category: {},
      isShow: false,
    };
  },
  computed: {
    ...mapGetters(ModuleCategory, ["TotalInfo"]),
  },
  async created() {
    const me = this;
    me.initDataStatic();
    await me.loadDataGrid();
  },
  methods: {
    ...mapActions(ModuleCategory, [
      "getCategories",
      "updateCategory",
      "deleteCategory",
      "getCategory",
    ]),
    handleTableChange: _.debounce(async function (page) {
      const me = this;
      me.pagination.current = page.current;
      me.pagination.pageSize = page.pageSize;
      me.pagination.total = page.total;
      await me.loadDataGrid();
    }, 300),
    loadDataFilter: _.debounce(async function (params) {
      const me = this;
      let payload = {
        ...me.payload,
        ...params,
        limit: me.pagination.pageSize,
        page: 1,
      };
      console.log(payload);

      await me.getCategories(payload);
    }, 300),
    initDataStatic() {
      const me = this;
      me.columns = [
        // {
        //   title: me.$t("i18nProduct.Id"),
        //   dataIndex: "Id",
        // },
        {
          fixed: "left",
          title: me.$t("i18nCommon.CategoryInfo.CategoryName"),
          dataIndex: "categoryName",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.categoryName, b.categoryName),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.CategoryInfo.CategoryDescription"),
          dataIndex: "cateDesc",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.cateDesc, b.cateDesc),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.CategoryInfo.Status"),
          dataIndex: "status",
          align: "center",
        },
        {
          title: me.$t("i18nCommon.Action"),
          key: "rightWidgetDefault",
          fixed: "right",
          width: 150,
        },
      ];
    },

    async loadDataGrid() {
      const me = this;
      let payload = {
        ...me.payload,
        limit: me.pagination.pageSize,
        page: me.pagination.current,
      };
      await me.getCategories(payload);
    },
    addData() {
      const me = this;
      me.$router.push("/create-category");
    },
    editRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) return;
      me.$router.push("/create-category");
      setTimeout(() => {
        me.$emitter.emit("LoadEditCategory", {
          id: dataRow.id,
          mode: me.$enum.Mode.Edit,
        });
      }, 300);
    }, 300),

    deleteRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) {
        me.$messageNotification.messageNotification(
          me.$t("i18nCommon.DeleteCategoryFail"),
          "warning"
        );
        return;
      }

      Modal.confirm({
        title: me.$t("i18nCommon.Confirm"),
        content: me.$t("i18nCommon.DeleteCategoryConfirm", {
          name: dataRow.categoryName,
        }),
        okText: me.$t("i18nCommon.Yes"),
        cancelText: me.$t("i18nCommon.No"),
        centered: true,
        async onOk() {
          let result = await me.deleteCategory({ id: dataRow.id });
          if (result && result.code == 200) {
            //Thông báo
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteCategorySuccess")
            );
            await me.loadDataGrid();
          } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
            me.$messageNotification.messageNotification(result.message, "warning");
          } else {
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteCategoryFail"),
              "warning"
            );
          }
        },
      });
    }, 300),

    async onDblclick(params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.category = await me.getCategory({ id: params.id });
      if (me.category) {
        me.isShow = true;
      } else {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
